const DECIMAL = /^(?:\d+|\d*\.\d+)$/;
const WHOLE = /^\d+$/;
const FRACTION = /^(\d+)\/(\d+)$/;
const INCH_SUFFIXES = ['inches', 'inch', 'in', '"'];

const withoutInchSuffix = (text: string): string => {
  const suffix = INCH_SUFFIXES.find(unit => text.toLowerCase().endsWith(unit));
  return suffix ? text.slice(0, -suffix.length).trimEnd() : text;
};

const fractionValue = (text: string): number | undefined => {
  const match = FRACTION.exec(text);
  if (!match || Number(match[2]) === 0) return undefined;
  return Number(match[1]) / Number(match[2]);
};

const partValue = (text: string): number | undefined => (DECIMAL.test(text) ? Number(text) : fractionValue(text));

export function parseInches(value: string): number | undefined {
  const text = withoutInchSuffix(value.trim());
  if (text.startsWith('-')) return undefined;
  const parts = text.split(/[\s-]+/).filter(Boolean);
  if (parts.length === 0 || parts.length > 2) return undefined;
  if (parts.length === 2 && !(WHOLE.test(parts[0]) && FRACTION.test(parts[1]))) return undefined;
  const values = parts.map(part => partValue(part));
  if (values.includes(undefined)) return undefined;
  const inches = (values as number[]).reduce((sum, part) => sum + part, 0);
  return inches > 0 ? inches : undefined;
}
